module.exports = __webpack_public_path__ + "static/media/intro.19e3a9b3.mp3";